<script lang="ts">
    import { untrack } from 'svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    interface Props {
        children?: import('svelte').Snippet;
    }

    const { children }: Props = $props();

    const wiring = injectWiring();

    $effect(() => {
        const trackingService = wiring.trackingService;
        if (!trackingService) return;
        untrack(() => {
            trackingService.trackPageCluster('Fehler');
        });
    });
</script>

<div class="reptile-fallback-result" data-qa="reptile-errorPage">
    <oc-banner-v1 variant="hint" size={'100'} hide-close-button icon-type="info-hint">
        Hoppla, da ist etwas schiefgegangen. Unser System hat einen Schluckauf – sollte schnell vorbei sein. Hier
        findest du Artikel, die dir auch gefallen könnten.
    </oc-banner-v1>
    {@render children?.()}
</div>
